import React from 'react';
import { COMMITMENTS } from '../../data/content';
import SectionHeader from '../SectionHeader';
import Callout from '../Callout';
import { useIntersection } from '../../hooks/useIntersection';

export default function Commitments() {
  const { ref, visible } = useIntersection();
  return (
    <section id="commitments" style={{ padding: '72px 0', borderBottom: '1px solid #D1D5DB' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
        <SectionHeader num={COMMITMENTS.sectionNum} title={COMMITMENTS.title} titleEm={COMMITMENTS.titleEm} body={COMMITMENTS.body} />
        <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>
          {COMMITMENTS.items.map((item, i) => (
            <div key={i} style={{ marginBottom: i < COMMITMENTS.items.length - 1 ? 32 : 0, paddingBottom: 32, borderBottom: i < COMMITMENTS.items.length - 1 ? '1px solid #D1D5DB' : 'none' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 12, flexWrap: 'wrap' }}>
                <span style={{
                  fontSize: 10, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase',
                  padding: '4px 10px', borderRadius: 4, flexShrink: 0, marginTop: 4,
                  background: 'var(--gpale)', color: 'var(--g2)', border: '1px solid var(--g2)',
                }}>{item.badge}</span>
                <h3 style={{ fontFamily: 'var(--serif)', fontSize: 22, color: 'var(--ink)', lineHeight: 1.2, fontWeight: 600 }}>{item.title}</h3>
              </div>
              <p style={{ fontSize: 15, color: 'var(--gray)', lineHeight: 1.8, maxWidth: 620 }}>{item.body}</p>
              <Callout>{item.callout}</Callout>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
